import React,{useRef,useState,useEffect} from 'react';

import { useParams } from 'react-router-dom';
// the hook
import { observer } from 'mobx-react';
import {useTranslation} from 'react-i18next';
import { LeftOutlined, RightOutlined, CommentOutlined, ThunderboltOutlined, CustomerServiceOutlined, ToolOutlined, MailOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import {Carousel,Tabs, Button } from 'antd';
import { http, addVisitLog, history } from 'libs';
import FormRow from "pages/goods/list/FormRow";
// import Login from '../login/index';
import gStore from 'store';
import store from './store';
import goodStore from 'pages/goods/store';
import cartStore from 'pages/cart/store';
import ListTemplate from './components/ListTemplate';

import style from './index.module.less'
import titleIcon1 from './titleIcon1.png';
import titleIcon2 from './titleIcon2.png';
import titleIcon3 from './titleIcon3.png';
import rightIcon1 from './rightIcon1.png';
import rightIcon2 from './rightIcon2.png';
import rightIcon3 from './rightIcon3.png';
import rightIcon4 from './rightIcon4.png';
import rightIcon5 from './rightIcon5.png';
import rightIcon6 from './rightIcon6.png';
import userAvatar from './user-avatar.png';
import banner1 from './banner1.png';
import banner2 from './banner2.png';
import category0 from './category0.png';
import category1 from './category1.png';
import category2 from './category2.png';
export default observer(function () {
  const {t, i18n} = useTranslation();// {t('')}
  const titleIconObj = {
    "设备":titleIcon1,
    "耗材":titleIcon2,
    "其他":titleIcon3,
  }
  const containerRef = useRef(null);
  const bannerCarousel = useRef(null);

  const searchParams = new URLSearchParams(window.location.search);
  // let params = searchParams.get('params')?.replaceAll(" ","+");
  const sign = searchParams.get('sign');
  const time = searchParams.get('time');
  const userEmail = searchParams.get('userEmail');
  const userName = searchParams.get('userName');
  const companyType = searchParams.get('companyType');
  if (sign) {
    http.post('/javaApi/user/thirdPartyLogin',{
      sign,time,userEmail,companyType,userName
    })
    .then( res => {
      const userInfo=res.data.result;
      gStore.userInfo = userInfo;
      cartStore.fetchRecords();
      localStorage.setItem('token', userInfo['token']);
      localStorage.setItem('nickname', userInfo['name']);
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      history.push('/home');
  }).catch( err => {
    localStorage.removeItem('token');
    localStorage.removeItem('nickname'); 
    localStorage.removeItem('userInfo'); 
  })
  }

  const searchMoreList = (item)=>{
    history.push(`./goods?params1=${item.value}`);
  }
  const goProductList = (item,secondItem)=>{
    addVisitLog({
      pageName: '首页左侧分类',
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}/goods`,
      eventCode: 'HomeLeftMallCategory',
      eventName: "首页左侧分类",
      content: JSON.stringify({'mallCategoryOne':item.value,'mallCategoryTwo':secondItem.value}),
    })
    history.push(`./goods?params1=${item.value}&params2=${secondItem.value}`);
  }

  const goBannerList = ()=>{
    addVisitLog({
      pageName: '首页第二个banner',
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}/goods/campaignDetail`,
      eventCode: 'HomeTwoBanner',
      eventName: "首页第二个banner",
    })
    history.push('/goods/campaignDetail')
  }
  const turnHandleModule = (url,eventCode,eventName)=>{
    addVisitLog({
      pageName: eventName,
      fromPageUrl: history.location.pathname,
      pageUrl:`${window.location.origin}${url}`,
      eventCode: eventCode,
      eventName: eventName,
    })
    history.push(url);
  }


  useEffect(()=>{
    store.fetchMallCategoryList();
    store.fetchHomeProductRecords();
    return ()=>{
      gStore.isLogin = false;
    }
  },[])
  
  let token = localStorage.getItem('token');
  return (
    <div className={style.homeContainer}>
      <div class="nav-module">
        <div class="main-content">
          <div class="category">
          <div class="sort-wrapper">
              <div class="sort-list-module">
                {store.mallCategoryNoAllList.map((item, index) => (
                       <div class="sort-list" key={item.value}>
                       <div class="one-level">
                           <div class="left">
                              <img src={titleIconObj[item.label]} alt="" />
                               <span>{ item.label }</span>
                           </div>
                           <div class="right">
                           </div>
                       </div>
                       <div class="two-level-wrapper">
                        {item.children.map((secondItem, index) => (
                           <div class="two-level" key={secondItem.value} onClick={()=>goProductList(item,secondItem)}>
                                <span> { secondItem.label }</span>
                            </div>
                          ))}
                       </div>
                   </div>
                ))}
              </div>
          </div>
          </div>
          <div class="banner">
            <Carousel ref={bannerCarousel} autoplay={true} height="406px" interval="4000">
                <img className='bannerImg' src={banner1} />
                <img className='bannerImg' src={banner2} onClick={()=>goBannerList()}/>
            </Carousel>
            <div class="arrow" onClick={()=>bannerCarousel.current.prev()}><LeftOutlined style={{color: '#fff'}} /></div>
            <div class="arrow rightArrow" onClick={()=>bannerCarousel.current.next()}><RightOutlined style={{color: '#fff'}} /></div>
          </div>
          <div class="mine">
            <div class="personal">
              <div class="user">
                {localStorage.getItem('token') ? (
                  <>
                  <div class="login-style">
                    <div class="avatar font0">
                      <img src={userAvatar} />
                    </div>
                    <div class="companyName">{ localStorage.getItem('nickname') }</div>
                    {/* <div class="det-info">
                      <span>{ localStorage.getItem('nickname') }</span>
                    </div> */}
                  </div>
                </>
                ): (
                  <>
                  <div class="not-login">
                    <div class="welcome">
                      <img src={userAvatar} />
                      <span>Hi，欢迎光临临床商城</span>
                    </div>
                    <div class="login-btn">
                      <Button type='primary' class="" onClick={()=>turnHandleModule('/login')}>登录</Button>
                    </div>
                  </div>
                </>
                )}
              </div>
              <div class="opera-area">
                <div class="work-item"  onClick={()=>turnHandleModule('/cart','HomeRightCart','首页右侧购物车')}>
                  <div class="work-icon"><img src={rightIcon1} /></div>
                  <div class="work-title">{ '购物车' }</div>
                </div>
                <div class="work-item"  onClick={()=>turnHandleModule('/user/purchase','HomeRightInquiry','首页右侧求购单')}>
                  <div class="work-icon"><img src={rightIcon2} /></div>
                  <div class="work-title">{ '求购单' }</div>
                </div>
                <div class="work-item"  onClick={()=>turnHandleModule('/user/quote','HomeRightQuote','首页右侧下单')}>
                  <div class="work-icon"><img src={rightIcon3} /></div>
                  <div class="work-title">{ '下单' }</div>
                </div>
                <div class="work-item"  onClick={()=>turnHandleModule('/user/order','HomeRightOrder','首页右侧订单明细')}>
                  <div class="work-icon"><img src={rightIcon4} /></div>
                  <div class="work-title">{ '订单明细' }</div>
                </div>
                <div class="work-item"  onClick={()=>turnHandleModule('/user/project','HomeRightProject','首页右侧项目管理')}>
                  <div class="work-icon"><img src={rightIcon5} /></div>
                  <div class="work-title">{ '项目管理' }</div>
                </div>
                <div class="work-item"  onClick={()=>turnHandleModule('/user/device/Sale','HomeRightSaleDevice','首页右侧设备管理')}>
                  <div class="work-icon"><img src={rightIcon6} /></div>
                  <div class="work-title">{ '设备管理' }</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FormRow/>
        <div className={style.submitBtnContainer}>
          <Button type="primary" ghost onClick={store.postInquiry}>
            确定
          </Button>
        </div>
        <div className={style['home-product-list']}>
            <div ref={containerRef}>
              {store.mallCategory.map((item, skuIndex) => (
                <div className={style['common-sort-module'] + ' marginT10'} id={`skuModule${skuIndex}`} key={skuIndex}>
                  <div className={style['header-area']}>
                    <div className={style['title']}>
                      <span className={style['classify-name']}>{item.label}</span>
                    </div>
                    {store.homeProductRecords[item.value]?.length > 0 && (
                      <div className={style['more']} onClick={() => searchMoreList(item)}>查看更多&gt;</div>
                    )}
                  </div>
                  <div className={style['sort-list']}>
                    <ListTemplate skuList={store.homeProductRecords[item.value]} previewUrl={skuIndex===0?category0:skuIndex===1?category1:category2} />
                  </div>
                </div>
              ))}
            </div>
          </div>
      </div>
    </div>
  )
})
